import { render, staticRenderFns } from "./DistributorPoster.vue?vue&type=template&id=0c71d356&scoped=true"
import script from "./DistributorPoster.vue?vue&type=script&lang=js"
export * from "./DistributorPoster.vue?vue&type=script&lang=js"
import style0 from "./DistributorPoster.vue?vue&type=style&index=0&id=0c71d356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71d356",
  null
  
)

export default component.exports